"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseHistoryService = void 0;
var axios_1 = __importDefault(require("axios"));
var UseHistoryTypes_1 = require("./UseHistoryTypes");
var PromptTypes_1 = require("Prompt/PromptTypes");
var UseHistoryEventName;
(function (UseHistoryEventName) {
    UseHistoryEventName["StepStarted"] = "Step Started";
    UseHistoryEventName["StepInteracted"] = "Step Interacted";
    UseHistoryEventName["StepSkipped"] = "Step Skipped";
    UseHistoryEventName["FlowStarted"] = "Flow Started";
    UseHistoryEventName["FlowInteracted"] = "Flow Interacted";
    UseHistoryEventName["FlowSkipped"] = "Flow Skipped";
})(UseHistoryEventName || (UseHistoryEventName = {}));
var FlowId;
(function (FlowId) {
    FlowId["Onboarding"] = "onboarding tooltips";
})(FlowId || (FlowId = {}));
var UseHistoryService = (function () {
    function UseHistoryService(apiBaseUrl, telemetry) {
        var _this = this;
        this.telemetry = telemetry;
        this.viewedPrompt = function (useHistory, stepId) { return __awaiter(_this, void 0, Promise, function () {
            var telemetryStepId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateTooltipPrompts(useHistory)];
                    case 1:
                        _a.sent();
                        if (stepId === UseHistoryTypes_1.onboardingSteps[0]) {
                            this.telemetry.track(UseHistoryEventName.FlowStarted, { flow_id: FlowId.Onboarding });
                        }
                        telemetryStepId = getTelemetryStepId(stepId);
                        if (telemetryStepId) {
                            this.telemetry.track(UseHistoryEventName.StepStarted, { step_id: getTelemetryStepId(stepId) });
                        }
                        return [2];
                }
            });
        }); };
        this.clickedPrompt = function (useHistory, stepId) { return __awaiter(_this, void 0, Promise, function () {
            var telemetryStepId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateTooltipPrompts(useHistory)];
                    case 1:
                        _a.sent();
                        if (stepId === UseHistoryTypes_1.onboardingSteps[UseHistoryTypes_1.onboardingSteps.length - 1]) {
                            this.telemetry.track(UseHistoryEventName.FlowInteracted, { flow_id: FlowId.Onboarding });
                        }
                        telemetryStepId = getTelemetryStepId(stepId);
                        if (telemetryStepId) {
                            this.telemetry.track(UseHistoryEventName.StepInteracted, { step_id: getTelemetryStepId(stepId) });
                        }
                        return [2];
                }
            });
        }); };
        this.dismissedPrompt = function (useHistory, stepId) { return __awaiter(_this, void 0, Promise, function () {
            var telemetryStepId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateTooltipPrompts(useHistory)];
                    case 1:
                        _a.sent();
                        if (UseHistoryTypes_1.onboardingSteps.includes(stepId)) {
                            this.telemetry.track(UseHistoryEventName.FlowSkipped, { flow_id: FlowId.Onboarding });
                        }
                        telemetryStepId = getTelemetryStepId(stepId);
                        if (telemetryStepId) {
                            this.telemetry.track(UseHistoryEventName.StepSkipped, { step_id: getTelemetryStepId(stepId) });
                        }
                        return [2];
                }
            });
        }); };
        this.updateTooltipPrompts = function (useHistory) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateField(useHistory, "prompts")];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.updateInlinePrompts = function (useHistory) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateField(useHistory, "inlinePrompts")];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.updateNewFeatureIndicators = function (useHistory) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateField(useHistory, "newFeaturesIndicator")];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.updateField = function (useHistory, field) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.post("".concat(this.url, "?field=").concat(field), useHistory[field], { withCredentials: true })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.update = function (useHistory) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.post(this.url, useHistory, { withCredentials: true })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.url = "".concat(apiBaseUrl, "/users/history");
    }
    return UseHistoryService;
}());
exports.UseHistoryService = UseHistoryService;
var getTelemetryStepId = function (stepId) {
    switch (stepId) {
        case PromptTypes_1.PromptId.Comments:
            return UseHistoryTypes_1.TelemetryStepId.Comments;
        case PromptTypes_1.PromptId.EditText:
            return UseHistoryTypes_1.TelemetryStepId.EditText;
        case PromptTypes_1.PromptId.Styles:
            return UseHistoryTypes_1.TelemetryStepId.Styles;
        case PromptTypes_1.PromptId.AddBlock:
            return UseHistoryTypes_1.TelemetryStepId.AddBlock;
        case PromptTypes_1.PromptId.Share:
            return UseHistoryTypes_1.TelemetryStepId.Share;
        case PromptTypes_1.PromptId.ContentLibrary:
            return UseHistoryTypes_1.TelemetryStepId.ContentLibrary;
    }
};
